import { onSendxData } from "../services/onSendxData";
import { onTokenValid } from '../services/onTokenValid';
//** CallBack Process Background */

export const iuseHooks = () => {
	const onToken = (recordSetting,dataRESP,stateHelper,stateDiss,setstateHelper,setstateDiss)=>{
		return onTokenValid(recordSetting,dataRESP,stateHelper,stateDiss,setstateHelper,setstateDiss)
		.then(value=>{
			return value
		})
	}
	
	const onProcess = (
		stateObjLoggin,
		stateObjPassword,
		stateHelper,
		setstateDiss,
		setstateHelper,
		setdataRESP
	) => {
		if (stateObjLoggin && stateObjPassword) {
			let { iu } = stateObjLoggin;
			let { pw } = stateObjPassword;
			if (pw !== "" && iu !== "") {
				setstateDiss({ diu: true, dpw: true, loggin: true });

				return onSendxData({ iu, pw }).then((resol) => {
					let { tiu, tpw,tkdsp } = resol;
					if (!tkdsp){
						if (tiu !== null) {
							setstateHelper({...stateHelper, tiu, tpw: "", epw: false, eiu: true });
						}
						if (tpw !== null) {
							setstateHelper({...stateHelper, tiu: "", tpw, epw: true, eiu: false });
						}
						setstateDiss({ diu: false, dpw: false, loggin: false });
						return true;
					}else{
						const { data } = resol;
						setdataRESP(data);
						setstateDiss({ diu:true, dpw: true, loggin: false });
						setstateHelper({ ...stateHelper,tiu: "", tpw:"", epw: false, eiu: false,dip:true });
						return false;
					}
					
				
				});
			}
		}
	};

	return { onProcess,onToken };
};
